import { render } from "./PokemonOptions.vue?vue&type=template&id=20f24ce9&scoped=true"
import script from "./PokemonOptions.vue?vue&type=script&lang=js"
export * from "./PokemonOptions.vue?vue&type=script&lang=js"

import "./PokemonOptions.vue?vue&type=style&index=0&id=20f24ce9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LF\\Desktop\\Vue\\pokemon-game\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f24ce9"]])

export default __exports__